import {createContext} from "react";

const QrContext = createContext({
	content: [],
	setContent: () => [],
});

export default QrContext;
